import { utils } from '@kurtosys/ksys-app-template';

export function isDebug(): boolean {
	const value = utils.url.getQueryStringValue({ key: 'ksysAppDebug' }, window.location.search);
	return value === 'true';
}